module.exports = __webpack_public_path__ + "static/img/invitation_logo.ffad959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/invitation_logo.png
// module id = WiBa
// module chunks = 3